import { useEffect, useRef } from "react";

import { SearchIcon } from "@/assets/icons/general/Search";
import { XIcon } from "@/assets/icons/ui/X";
import { IconButton } from "@/components/ui/buttons/IconButton/IconButton";
import { TextInput } from "@/components/ui/inputs/TextInput/TextInput";

interface SearchJobsProps {
  search: string;
  setSearch: (search: string) => void;
}
export const SearchJobs = ({ search, setSearch }: SearchJobsProps) => {
  const blurTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (blurTimeoutRef.current) {
        clearTimeout(blurTimeoutRef.current);
      }
    };
  }, []);
  const clearSearch = () => {
    setSearch("");
  };
  return (
    <div className="mx-auto flex max-w-[100%]">
      <div className="relative w-full">
        <TextInput
          icon={SearchIcon}
          placeholder="Search for jobs"
          hideLabel
          label="Search"
          variant="search"
          value={search}
          onFocus={() => {
            if (blurTimeoutRef.current) {
              clearTimeout(blurTimeoutRef.current);
              blurTimeoutRef.current = null;
            }
          }}
          onBlur={() => {
            if (blurTimeoutRef.current) {
              clearTimeout(blurTimeoutRef.current);
            }
            blurTimeoutRef.current = setTimeout(() => {}, 200);
          }}
          onChange={(e) => setSearch(e.target.value)}
        />
        {search && (
          <IconButton
            label="x"
            variant="transparent"
            icon={XIcon}
            className="absolute top-3 right-1 h-3 w-3 p-height-s text-text-inverted-tertiary"
            iconClassName="w-3 h-3"
            onPress={clearSearch}
          />
        )}
      </div>
    </div>
  );
};
